import axiosInstance from "auth/FetchInterceptor";
import {
  CHANGE_STATUS_DRIVER,
  CREATE_DRIVER,
  DRIVER_API,
  GET_ALL_DRIVER,
  SUMMARY_DRIVER,
  UPDATE_DRIVER,
  GET_ALL_ACTIVE_DRIVER,
  MOBILE_DRIVER_REPORT,
  MOBILE_DRIVER_HISTORY_MONITORING,
  GET_DRIVERS_VALID,
  ASSIGN_DRIVER,
} from "constants/ApiConstant";
const DriverService = {};

DriverService.getDriverSummary = function () {
  return axiosInstance.get(SUMMARY_DRIVER, null);
};

DriverService.getAllDriver = function (data) {
  return axiosInstance.post(GET_ALL_DRIVER, data);
};

DriverService.getDriverById = function (id) {
  return axiosInstance.get(`${DRIVER_API}/${id}`, null);
};

DriverService.createDriver = function (data) {
  return axiosInstance.post(CREATE_DRIVER, data);
};

DriverService.updateDriver = function (data) {
  return axiosInstance.put(UPDATE_DRIVER, data);
};

DriverService.changeStatusDriver = function (data) {
  return axiosInstance.put(CHANGE_STATUS_DRIVER, data);
};

DriverService.delDriver = function (id) {
  return axiosInstance.delete(`${DRIVER_API}/${id}`, null);
};

DriverService.getAllActiveDriver = function () {
  return axiosInstance.get(GET_ALL_ACTIVE_DRIVER, null);
};
DriverService.monitoringMobileDriver = function (data) {
  return axiosInstance.post(MOBILE_DRIVER_REPORT, data);
};
DriverService.monitoringMobileDetailDriver = function (id) {
  return axiosInstance.get(`${MOBILE_DRIVER_REPORT}/${id}`, null);
};
DriverService.monitoringHistoryDriver = function (id) {
  return axiosInstance.get(`${MOBILE_DRIVER_HISTORY_MONITORING}/${id}`, null);
};

DriverService.getDriversValid = function (data) {
  return axiosInstance.get(`${GET_DRIVERS_VALID}/${data.tripId}`, null);
};
DriverService.assignDriver = function (data) {
  return axiosInstance.put(ASSIGN_DRIVER, data);
};

export default DriverService;
